// V3 doesn't change JMS schema. It changes some internal PHX type validation in v0.30.0
export const migrateToV3 = (state)=>state;

//# sourceMappingURL=v03.js.map